export default __webpack_public_path__ + "static/media/menu-icon.25736866.svg";